export default {

  /** 新增巡查点位 */
  insertPaInspectPoint: '/ygsjzs/paInspectPoint/insertPaInspectPoint',
  /** 修改巡查点位 */
  updatePaInspectPoint: '/ygsjzs/paInspectPoint/updatePaInspectPoint',
  /** 删除巡查点位 */
  deletePaInspectPoint: '/ygsjzs/paInspectPoint/deletePaInspectPoint',
  /** 查询巡查点位详情 */
  selectPaInspectPointByPointId: '/ygsjzs/paInspectPoint/selectPaInspectPointByPointId',
  /** 分页查询巡查点位列表 */
  selectPaInspectPointByPage: '/ygsjzs/paInspectPoint/selectPaInspectPointByPage'
}
